import { Table, TableBody, TableContainer, TableRow } from "@mui/material";
import { Header } from "~/types/table";
import { TableHead } from "~/pages/inventory/components/TableHead";
import { Link as RouterLink } from "react-router-dom";
import { TitleCell } from "~/pages/inventory/components/AssetSoftware/AssetSoftwareTable/TitleCell";
import { FirstFoundCell } from "~/pages/inventory/components/AssetSoftware/AssetSoftwareTable/FirstFoundCell";
import { ImpactCell, RiskFactorsCell } from "~/components/Cells";
import { AssetPackageNodeType } from "~/pages/inventory/components/AssetSoftware/types";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { useSort } from "~/pages/inventory/hooks/useSort";

type SoftwareTableProps = {
  scope: SpaceOrWorkspaceScope;
  packages: Array<AssetPackageNodeType>;
  assetMrn: string;
  sort: ReturnType<typeof useSort>;
};

export const SoftwareTable = ({
  scope,
  packages,
  assetMrn,
  sort,
}: SoftwareTableProps) => {
  const tableHeaders: Header[] = [
    {
      id: "RISK_VALUE",
      label: "Risk",
      options: { width: "10%" },
    },
    {
      id: "PACKAGE_NAME",
      label: "Package",
      options: { width: "50%" },
    },
    {
      id: "RISK_FACTORS",
      label: "Risk factors",
    },
    {
      id: "FIRST_FOUND",
      label: "First found",
    },
  ];

  return (
    <TableContainer>
      <Table>
        <TableHead tableHeaders={tableHeaders} sort={sort} />
        <TableBody>
          {packages.map((pckg, index) => (
            <TableRow
              key={index}
              component={RouterLink}
              to={`/space/software/${pckg.packageName}?${scope.params}&assetMrn=${assetMrn}&softwareMrn=${encodeURIComponent(pckg.mrn)}`}
            >
              <ImpactCell
                impact={pckg.riskValue}
                rating={pckg.rating}
                data-testid="software-impact"
                isActive
              />
              <TitleCell pckg={pckg} data-testid="software-title" />
              <RiskFactorsCell
                riskFactors={pckg.riskFactors}
                data-testid="software-risk-factors"
              />
              <FirstFoundCell pckg={pckg} data-testid="software-first-found" />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
